import moment from 'moment';

export const formatTimeForApi = (time: string): string => {
  return moment(time, 'h:mmA').format('HH:mm:ss');
};

export const formatTimeForDisplay = (time: string): string => {
  return moment(time, 'HH:mm:ss').format('h:mma');
};
